import { EMPTY_MASTER_PARTICIPATION_RATEANY_MODEL } from "presentation/model/ParticipationRate/ParticipationRateMaintenanceModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: ParticipationRateMaintenanceProvider,
    useTracked: useParticipationRateMaintenanceTracked
} = createContainer(() => useState(EMPTY_MASTER_PARTICIPATION_RATEANY_MODEL), {concurrentMode: true});
export { ParticipationRateMaintenanceProvider, useParticipationRateMaintenanceTracked };

